import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { faqs } from "../data/landing";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white py-16 md:py-24" data-id="element-39" data-mp="1gj3njwjhxbrj">
      <div className="mx-auto max-w-[820px] px-5 sm:px-8" data-id="element-40" data-mp="1gjvgezlpkve4">
        <SectionHead eyebrow="Before you buy" title="Your questions," highlight="answered." data-id="element-41" data-mp="248y16gbn34cu" />
        <div className="space-y-3" data-id="element-42" data-mp="28b1df764ucz6">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="rounded-xl border border-line bg-white shadow-[0_6px_20px_rgba(19,34,56,0.05)]" data-id="element-43" data-mp="1uj4n98o0yd5f" data-mpi={i}>
                <h3 data-id="element-44" data-mp="1zg4vnq8cjrzp">
                  <button type="button" id={`faq-q-${i}`} aria-expanded={isOpen} aria-controls={`faq-a-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-base font-semibold text-navy sm:px-6" data-id="element-45" data-mp="2n8btyuxmu91r">
                    {faq.q}
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-teal text-white" : "bg-soft text-teal"}`} data-id="element-46" data-mp="1emogejzgcn2d">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="1jmas2ozmtv92" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-48" data-mp="1skmrngih83dn">
                  {isOpen && <motion.div id={`faq-a-${i}`} role="region" aria-labelledby={`faq-q-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-49" data-mp="35omxl1dc26r">
                      <p className="px-5 pb-5 text-[15px] text-ink/80 sm:px-6" data-id="element-50" data-mp="2c8w2vwiaymax">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}